import { Link } from "react-router-dom";

export default function ProductListItem( { item } ){
    let name = item.properties.Name?.title[0]?.plain_text;
    let categories = item.properties.Category?.multi_select;
    let thumbnail = item.icon?.file?.url;
    let summary = item.properties?.Summary?.rich_text[0]?.plain_text
    
    return(
        <Link to = {`/products/${item.id}`} >
            <div className = "productsList">
                <img style = { { width : "384px", border : "transparent" } } src = { thumbnail }/>
                
                <div style = { { display : "flex", flexDirection : "column", height : "100%", flex : 1, padding : "24px", alignItems : "flex-start", justifyContent : "flex-start" } }>
                    <p className = "title">{ name }</p>
                    <p className = "meta3" style = { { marginBottom : "8px" } }>{ categories?.map(item => item.name).join(", ") }</p>
                    <p className = "productItemSummary">{ summary }</p>
                </div>
            </div>
        </Link>
    )
}